import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../../dialogFooter'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import HandleErrorService from '../../../app/service/handleErrorService'

class DadosPagamentoSalvoParcelaProvisaoDialog extends React.Component {

    constructor(){
        super()
        this.provisaoService = new ProvisaoService()
    }

    state = {
        dadosPagamento: {},
        didUpdated: false,
    }

    componentDidUpdate(){
        // console.log("componentDidUpdate: ", this.props.idParcelaToViewDadosPagamento)
        if(this.props.idParcelaToViewDadosPagamento && !this.state.didUpdated){
            // console.log("busca!")
            this.searchDadosPagamento()
            this.setState({didUpdated: true})
        }
    }

    searchDadosPagamento = () => {
        this.provisaoService.searchDadosPagamento(this.props.idParcelaToViewDadosPagamento)
        .then(response => {
            // console.log("response.data: ", response.data)
            this.setState({dadosPagamento: response.data})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    hideDialog = async () => {
        this.setState({
            dadosPagamento: {},
        })
        await this.props.hideDialog()
        this.setState({didUpdated: false})
    }

    render(){

        const footer = (
            <DialogFooter hideDialog = {this.hideDialog} disabled/>
        )

        const renderDadosPagamento = () => {
            return (
                <div
                    style={{marginBottom: '10px'}}
                >
                    <li>
                        <strong>Usuário:</strong> {this.state.dadosPagamento.usuario}
                    </li>

                    <li>
                        <strong>Conta Bancária:</strong> {this.state.dadosPagamento.contaBancaria ? this.state.dadosPagamento.contaBancaria.formattedName : ''}
                    </li>
                    
                    <li>
                        <strong>Data do pagamento:</strong> {this.state.dadosPagamento.dataEfetivoPagamento}
                    </li>
                    
                    <li>
                        <strong>Data/Hora da confirmação do pagamento pelo usuário:</strong> {this.state.dadosPagamento.dataHoraConfirmacaoPaganeto}
                    </li>
                    
                    <li>
                        <strong>Observações:</strong> {this.state.dadosPagamento.observacao}
                    </li>

                </div>                
            )
        }

        return(

            <Dialog
                header={"Dados de Pagamento"}
                visible={this.props.visible} style={{ width: '90%' }}
                modal
                className="p-fluid"
                footer={footer}
                onHide={this.hideDialog}
            >

                <div >
                    <div className='row '>
                        {renderDadosPagamento()}
                    </div>
                    
                </div>

            </Dialog>

        )
    }

}

export default DadosPagamentoSalvoParcelaProvisaoDialog